import { useNavigate, useSearch } from '@tanstack/react-router'
import { NotesSection } from './NotesSection'
import { useCrewNotesList } from '../lib/hooks'
import { useCrewNoteDelete } from '../lib/hooks/trip'
import { useCurrentCrewMember } from '@/hooks/useCurrentCrewMember'

export function HomeNotes() {
  const { data: currentUser } = useCurrentCrewMember()
  const { data: notes } = useCrewNotesList()
  const { mutate: deleteCrewNote } = useCrewNoteDelete()
  const navigate = useNavigate()
  const { note: viewNoteId } = useSearch({ from: '/_auth/home' })

  const crewId = currentUser?.id
  if (!crewId) return null

  return (
    <NotesSection
      title="My Notes"
      notes={notes}
      parent={{ crewId }}
      onDirectDelete={(id, cbs) => deleteCrewNote({ id }, cbs)}
      viewNoteId={viewNoteId ?? null}
      onViewNoteIdChange={(id) =>
        navigate({
          to: '/home',
          search: (prev) => ({ ...prev, note: id ?? undefined }),
        })
      }
    />
  )
}
